module.exports = __webpack_public_path__ + "static/media/bctc-tas-simple-logo.e8bf4e8c.svg";